<template>
  <div class="page__wrapper">
    <div class="container-static">
      <template
        v-for="(block, i) in blocks"
        :key="`static-block-${i}`"
      >
        <div
          v-if="block.type === 'image'"
          class="image__wrapper">
          <img
            v-if="block.src"
            :src="block.src"
            alt=""
            srcset=""
          >
        </div>
        <div
          v-if="block.type === 'html'"
          v-html="block.value"
          class="inner-html"
        ></div>
        <p
          v-if="block.type === 'text'"
          class="break-line"
        >
          {{ block.value }}
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import StaticPage from '@/components/mixins/methodsStaticPage';

export default {
  name: 'StaticPageView',
  mixins: [appBaseNav, StaticPage],
  props: {
    alias: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      blocks: [],
    };
  },
  watch: {
    alias() {
      this.loadPage();
    },
    $route(to) {
      if (to.hash) {
        const toElement = document.getElementById(to.hash.replace('#', ''));
        if (toElement) toElement.scrollIntoView();
      } else {
        document.getElementById('content__wrapper').scrollTo(0, 0);
      }
    },
  },
  beforeMount() {
    this.loadPage();
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        const toElement = document.getElementById(this.$route.hash.replace('#', ''));
        if (toElement) toElement.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  },
  methods: {
    loadPage() {
      this.$emit('loading', true);
      this.getPage(this.alias)
        .then((content) => {
          this.$emit('loading', false);
          this.$store.commit('setPageTitle', content?.title || null);
          this.blocks = Array.isArray(content?.blocks) ? [...content.blocks] : [];
        })
        .catch((error) => {
          this.$emit('loading', false);
          // eslint-disable-next-line no-console
          console.error('StaticPageView::', error);
        });
    },
  },
};
</script>
<style lang="scss">
.page {
  &__wrapper {
    padding: 24px 12px 0;
  }
}
.image__wrapper {
  display: flex;
  justify-content: center;
  overflow: auto;
  img {
    // max-height: calc(var(--vh, 1vh) * 100 - 166px);
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
